import axios from "axios";
import { API_URL } from "utils/constants";

const axiosInstance = axios.create({
  baseURL: API_URL,

  headers: {
    "Content-Type": "application/json",
  },
});

export const handleUserVerifyWithOTV = async (data) => {
  const response = await axiosInstance.post("/v1/Auth/send/code", data);

  return response.data;
};

export const handleUserLoginWithOTP = async (userCredentials) => {
  const response = await axiosInstance.post(
    "/v1/Auth/login/code",
    userCredentials
  );

  return response.data;
};
